import { LOCATION_URL, LOCATION_API_TOKEN, authToken } from '../env'
import axios from '../_client'
import { EventBus } from '@/event-bus'
const locationAxiosInstaceV1 = axios.create({
    baseURL: `${LOCATION_URL}`,
    headers: {
        'api-token': LOCATION_API_TOKEN
    }
})
locationAxiosInstaceV1.interceptors.response.use(function (response) {
    if (response.data.redirect_to) {
        location.href = response.data.redirect_to
    }
    return response
}, function (error) {
    if (error.response.status === 401 || error.response.status === 403) {
        EventBus.$emit('unauthorized')
    }
    if (error.response.status !== 404) {
        EventBus.$emit('show-error-modal', error)
    }
    return Promise.reject(error)
})
export const LocationAPI = {
    /**
     * Fetch data
     */
    fetch(businessId) {
        return locationAxiosInstaceV1({
            method: 'get',
            url: `/clients/businesses/${businessId}/locations?operation_hours=true&address=true&contact_details=true&images=true&page=1&limit=400`,
            headers: {
                'auth-token': authToken()
            }
        })
    }
}
